import createAxios from './http'
import getSign from '@/core'
import encryptPhone from '@/core/phone'
import { saveUserId, savePhone, getSecret, getKey } from '../common/js/cache'

const request = createAxios()
/**
* 拦截请求
*
*/
request.interceptors.request.use(
  config => {
    const accessSecret = getSecret()
    const accessKey = getKey()

    const timestamp = (new Date()).valueOf()
    const { phone } = config.params
    const signData = {
      phone: phone,
      timestamp: timestamp,
      accessKey
    }
    const sign = getSign(signData, accessSecret)
    config.params.timestamp = timestamp
    config.params.accessKey = accessKey
    config.params.sign = sign
    config.params.phone = phone
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

/**
 * 用户登录
 */
export function loginByPhone (params) {
  const { phone } = params
  const ePhone = encryptPhone(phone)
  // const ePhone = '~a71p4qaqgkwgch'
  return request({
    url: '/user/getUserByPhone.htm',
    method: 'post',
    params: { phone: ePhone }
  }).then((res) => {
    if (res.code == 9000200){
      saveUserId(res.result)
      savePhone(ePhone)
    }
    return res
  })
}



export function mxAuthentication (params) {
  return request({
    url: '/partner/mxAuthentication.htm',
    method: 'post',
    params
  })
}

